import { createRequestHelper } from '@utils/swr'
import { type LineOaStatusResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<ECommerceApis['get']['lineOaStatus'], LineOaStatusResponse, boolean>({
  client: 'eCommerce',
  /* 身份取自 x-platform-token。 */
  key: (shouldFetch = true) => shouldFetch ? '/line-oa/status' : null,
})

export const useApiLineOaStatus = useRequest
